import { initializeApp, FirebaseApp } from "firebase/app";
import { getMessaging, getToken as getFirebaseToken } from "firebase/messaging";
import { useCallback, useEffect, useMemo, useRef } from "react";

export const FIREBASE_SERVICE_WORKER_PATH = "/firebase-messaging-sw.js";

export const useFirebase = () => {
  const ready = useRef<boolean>(false);

  useEffect(() => {
    ready.current = true;
  }, [ready]);

  const app = useMemo(
    (): FirebaseApp =>
      initializeApp({
        apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
        authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
        projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
        storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
        measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
      }),
    [],
  );

  const getToken = useCallback(async (): Promise<string> => {
    if (!ready.current) return "";

    return await getFirebaseToken(getMessaging(app), {
      vapidKey: process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY,
    });
  }, [ready, app]);

  return { getToken };
};
